export const siteSettings = {
  name: "Apex Finex",
  link: "https://apexfinex.live",
  email: "support@apexfinex.live",
  appLink: "https://app.apexfinex.live",
};
